<script>
  import _ from 'lodash'
  import moment from 'moment'
//   import Vue from 'vue'
  import { mapGetters } from 'vuex'
//   import VueFullcalendar from '@/components/VueFullcalendar'
  import EventBus from '@/components/EventBus'
  import OrgService from '@/request/user/org'
  import OperationService from '@/request/aims/operation'
  import PermissionUtils from '@/utils/permission'
  import NurseService from '@/request/aims/nurse'
  import AnesthesiologistService from '@/request/aims/anesthesiologist'
  import AnesthesiaModeService from '@/request/aims/anesthesiaMode'
  import md5 from 'js-md5'
//   Vue.use(VueFullcalendar)
  export default {
    computed: {
        ...mapGetters('operation', {
            options: 'options'
        }),
        ...mapGetters({
            permissions: 'permissions'
        })
    },
    components: {},
    data () {
        return {
            cardBodyStyle: {
                padding: '15px',
                height: '650px'
            },
            tableCellStyle: {
                padding: 0
            },
            emergencyImage: require('@/assets/emergency.png'),
            hospitals: [],
            currentHospital: {},
            chid: null,
            oids: [],
            dnumbers: [],
            currentDate: null,
            listState: 'calendar',
            operationLoading: false,
            operations: [],
            visibleOperationInfo: false,
            currentOperation: {},
            visiblePrintList: false,
            visibleRecordImage: false,
            visibleUpdateDate: false,
            operationDate: null,
            dateSelection: [],
            approveCount: null,
            dnumberCount: {},
            visibleEditOperation: false,
            editOperation: {},
            arrageStore: {},
            personSelection: {
                nurse: [],
                doc: [],
                anesthesia: [],
                operations: [],
            }
        }
    },
    created: function () {
        this.chid = this.options.hid || null
        this.currentDate = this.options.date || moment().startOf('day').valueOf()
        this.createDateNumbers()
        this.listHospital()
        this.listPerson()
        EventBus.$on('websocket-message', this.handleWebsocket)
    },
    mounted: function () {},
    beforeDestroy: function () {
        EventBus.$off('websocket-message', this.handleWebsocket)
    },
    watch: {
        'chid': function (val) {
            this.options.hid = val
            if (val) {
                let index = _.findIndex(this.hospitals, {'id': val})
                if (index >= 0) {
                    this.currentHospital = _.cloneDeep(this.hospitals[index])
                }
            }
            this.listOids()
            this.personSelection = {
                nurse: [],
                doc: [],
                anesthesia: [],
                operations: [],
            }
            this.listPerson()
        },
        'oids': function () {
            this.countOperation()
            this.listOperation()
        },
        permissions () {
            this.countOperation()
        },
        'currentDate': function (val) {
            this.options.date = val
            this.listOperation()
        }
    },
    methods: {
        hasPermission (sns) {
            return PermissionUtils.hasPermission(sns, this.$store.getters.permissions, false)
        },
        listHospital () {
            OrgService.listOrg({
                parents: 1,
                descendant: 1,
                typeSns: 'lx0001001'
            }).then(res => {
                this.hospitals = _.cloneDeep(res.result || [])
                if (_.isEmpty(this.hospitals)) {
                    return
                }
                if (!this.chid) {
                    this.chid = this.hospitals[0].id
                    return
                }
                this.listOids()
                if (_.isEmpty(this.currentHospital)) {
                    let index = _.findIndex(this.hospitals, {'id': this.chid})
                    if (index >= 0) {
                        this.currentHospital = _.cloneDeep(this.hospitals[index])
                    }
                }
            })
        },
        createDateNumbers () {
            const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
            let dns = []
            let count = 7
            let mid = _.floor(count / 2)
            for (let i = 0; i < count; i++) {
                let number = i - mid
                let value = moment().add(number, 'd')
                let name = weeks[value.day()]
                switch (number) {
                    case 0:
                    name = '今天'
                    break
                    case 1:
                    name = '明天'
                    break
                    case 2:
                    name = '后天'
                    break
                    case -1:
                    name = '昨天'
                    break
                    case -2:
                    name = '前天'
                    break
                }
                dns.push({
                    value: value.startOf('day').valueOf(),
                    name: name
                })
                this.$set(this.dnumberCount, value.startOf('day').valueOf(), null)
            }
            this.dnumbers = _.sortBy(dns, ['value'])
        },
        listOids () {
            let self = this
            if (!self.chid) {
                self.oids = []
                return
            }
            OrgService.listOrgId({
                pids: self.chid,
                descendant: 1
            }).then(res => {
                self.oids = res.result || []
            })
        },
        listOperation () {
            let self = this
            self.operations = []
            if (_.isEmpty(self.oids) || !self.currentDate) {
                return
            }
            self.operationLoading = true
            let poperation = OperationService.list({
                start: self.currentDate,
                end: moment(self.currentDate).endOf('day').valueOf(),
                orgs: _.join(self.oids),
                status: '3,4,5'
            })
            poperation.then(res => {
                let data = res.result || []
                self.operations = _.sortBy(data, ['arrangedStartTime', 'room'])
            })
            poperation.finally(() => {
                self.operationLoading = false
            })
        },
        countOperation () {
            let self = this
            if (_.isEmpty(self.oids)) {
                return
            }
            OperationService.count({
                orgs: _.join(self.oids),
                status: '2'
            }).then(res => {
                this.approveCount = res.result || null
            }).catch(() => {
                this.approveCount = null
            })
            if (this.hasPermission('per_opration_001003')) {
                _.forEach(this.dnumberCount, (value, key) => {
                    if (!key) {
                        return
                    }
                    let date = parseInt(key)
                    OperationService.count({
                        start: date,
                        end: moment(date).endOf('day').valueOf(),
                        orgs: _.join(self.oids),
                        status: '3'
                    }).then(res => {
                        this.$set(this.dnumberCount, date, res.result || null)
                    }).catch(() => {
                        this.$set(this.dnumberCount, date, null)
                    })
                })
            }
        },
        saveStore(operation) {
            // let sn = operation.room + ':' + operation.arrangedStartTime;
            let sn = this.md5(operation)
            if (!this.arrageStore[operation.id]) {
                this.arrageStore[operation.id] = []
            }
            if (_.indexOf(this.arrageStore[operation.id], sn) < 0) {
                this.arrageStore[operation.id].push(sn)
            }
        },
        hasStore(operation) {
            let store = this.arrageStore[operation.id]
            if (store) {
                // let sn = operation.room + ':' + operation.arrangedStartTime
                let sn = this.md5(operation)
                let at = _.lastIndexOf(store, sn);
                if (store.length === 0) {
                    delete this.arrageStore[operation.id]
                }
                if (at >= 0) {
                    return true;
                }
            }
            return false
        },
        md5(operation) {
            let obj = {
                sn: operation.sn,
                arrangedStartTime: operation.arrangedStartTime,
                duration: operation.duration,
                room: operation.room,
                currentState: operation.currentState,
                assistantFirst: operation.assistantFirst,
                assistantSecond: operation.assistantSecond,
                washNurse: operation.washNurse,
                tourNurse: operation.tourNurse,
                anesthesiaDoc: operation.anesthesiaDoc,
                remark: operation.remark
            }
            return md5(JSON.stringify(obj))
        },
        handleWebsocket (data) {
            if (!data) {
                return
            }
            if (_.isString(data)) {
                data = JSON.parse(data)
            }
            if (!data.source || data.source !== 'eber-system-aims') {
                return
            }
            if (_.isEmpty(this.oids)) {
                return
            }
            let operation = data.message
            let oid = operation.oid
            if (_.indexOf(this.oids, oid) < 0) {
                return
            }
            this.countOperation()
            if (this.hasStore(operation)) {
                return;
            }
            /* let storeIndex = _.indexOf(this.arrageStore, operation.id)
            if (storeIndex >= 0) {
                this.arrageStore.splice(storeIndex, 1)
                return;
            } */
            if (data.topic === 'aims-operation-save') {
                this.updateOperation(operation)
            } else if (data.topic === 'aims-operation-delete') {
                _.remove(this.operations, item => {
                    return item.id === operation.id
                })
            }
        },
        updateOperation (operation) {
            if (!operation) {
                return
            }
            let ops = this.operations
            let add = true
            let time = (operation.currentState === 4 || operation.currentState === 5) ? operation.arrangedStartTime : operation.startTime
            if (time < this.currentDate || time > moment(this.currentDate).endOf('day').valueOf()) {
                add = false
            }
            if (operation.currentState < 3 || operation.currentState > 5) {
                add = false
            }
            let index = _.findIndex(ops, {'id': operation.id})
            if (index < 0) {
                add && ops.push(operation)
            } else {
                if (add) {
                    ops[index] = operation
                } else {
                    ops.splice(index, 1)
                }
            }
            this.operations = _.sortBy(ops, ['arrangedStartTime', 'room'])
        },
        operationSelectionSaveDone (operation) {
            if (_.isEmpty(operation)) {
                return
            }
            /* if (_.indexOf(this.arrageStore, operation.id) < 0) {
                this.arrageStore.push(operation.id)
            } */
            this.saveStore(operation)
            this.updateOperation(operation)
        },
        handleClickOperation (operation) {
            if (!operation) {
                return
            }
            operation = _.find(this.operations, o => o.id === operation.id)
            this.currentOperation = _.cloneDeep(operation)
            this.visibleOperationInfo = true
        },
        handlerDropInArrangeList(operation) {
            this.$refs.aimsWaitList.removeWaitOperation(operation)
            this.saveStore(operation)
            this.updateOperation(operation)
        },
        handlerDropMoveArrangeList(operation) {
            this.saveStore(operation)
            this.updateOperation(operation)
        },
        handlerDropInError(operation) {
            this.$refs.aimsWaitList.updateWaitOperation(operation)
            this.saveStore(operation)
            this.updateOperation(operation)
        },
        tableTimeFormatter (row, column, cellValue) {
            if (!cellValue) {
                return ''
            }
            return moment(cellValue).format('HH:mm') + '-' + moment(cellValue + row.duration).format('HH:mm')
        },
        cancleArrange (operation) {
            if (!operation || !operation.id) {
                return
            }
            if (operation.currentState !== 4) {
                this.$message.error(new Error('只能对已经排班的手术进行此操作'))
                return
            }
            this.$confirm('确认取消[' + operation.patName + ']的手术的排班状态吗?取消后可重新排班', '提示', {type: 'warning'}).then(() => {
                OperationService.cancel({id: operation.id}).then(res => {
                    operation = _.clone(res.result || {})
                    if (_.isEmpty(operation)) {
                        return
                    }
                    /* if (_.indexOf(this.arrageStore, operation.id) < 0) {
                        this.arrageStore.push(operation.id)
                    } */
                    this.saveStore(operation)
                    this.updateOperation(operation)
                    if (this.$refs.aimsWaitList) {
                        this.$refs.aimsWaitList.updateWaitOperation(operation)
                    }
                    if (this.$refs.aimsArrangeList) {
                        this.$refs.aimsArrangeList.cancleArrange(operation)
                    }
                    this.$message({
                        message: '操作完成，可以重新排班了！',
                        type: 'success'
                    })
                    this.visibleOperationInfo = false
                }).catch(error => {
                    this.$message.error(error || '操作失败')
                })
            }, () => {
                this.$message({
                    message: '取消操作!',
                    type: 'info'
                })
            })
        },
        backOperation (operation) {
            if (!operation || !operation.id) {
                return
            }
            this.$confirm('确认退回[' + operation.patName + ']的手术吗?', '提示', {type: 'warning'}).then(() => {
            this.$prompt('请输入退回原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: '退回原因不能为空',
                inputPlaceholder: '请输入原因'
            }).then(({ value }) => {
                OperationService.back({
                    id: operation.id,
                    currentState: 7,
                    backReason: value
                }).then(res => {
                    operation = _.clone(res.result || {})
                    if (_.isEmpty(operation)) {
                        return
                    }
                    /* if (_.indexOf(this.arrageStore, operation.id) < 0) {
                        this.arrageStore.push(operation.id)
                    } */
                    this.saveStore(operation)
                    this.updateOperation(operation)
                    this.$message({
                        message: '操作完成！',
                        type: 'success'
                    })
                    this.visibleOperationInfo = false
                }).catch(error => {
                    this.$message.error(error || '操作失败')
                })
            }).catch(() => {
                this.$message({
                    message: '取消操作!',
                    type: 'info'
                    })
                })
            }).catch(() => {
                this.$message({
                    message: '取消操作!',
                    type: 'info'
                })
            })
        },
        createDateSelection () {
            const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
            let min = moment().startOf('day').valueOf()
            let max = moment().add(3, 'd').endOf('day').valueOf()
            let ds = []
            let step = moment(max).diff(min, 'days') + 1
            for (let i = 0; i < step; i++) {
                let date = moment(min).clone().add(i, 'days').startOf('day').valueOf()
                let alias = '今天'
                let diff = moment(date).diff(moment().startOf('day'), 'days')
                if (diff === 0) {
                    alias = '今天'
                } else if (diff === 1) {
                    alias = '明天'
                } else if (diff === 2) {
                    alias = '后天'
                } else {
                    alias = weeks[moment(date).day()]
                }
                let item = {
                    value: date,
                    name: moment(date).format('YYYY年MM月DD日') + '(' + alias + ')'
                }
                ds.push(item)
            }
            this.dateSelection = _.clone(ds)
        },
        startUpdateDate (operation) {
            if (!operation) {
                return
            }
            this.createDateSelection()
            this.currentOperation = _.cloneDeep(operation)
            this.operationDate = moment(operation.startTime).startOf('day').valueOf()
            this.visibleUpdateDate = true
        },
        handleCloseUpdateDate () {
            this.operationDate = null
        },
        updateDate () {
            let oldDate = moment(this.currentOperation.startTime).startOf('day').valueOf()
            if (oldDate !== this.operationDate) {
            OperationService.updateDate({
                id: this.currentOperation.id,
                date: this.operationDate
            }).then(res => {
                this.$message({
                    message: '修改手术日期完成',
                    type: 'success'
                })
                this.visibleUpdateDate = false
                this.visibleOperationInfo = false
                let operation = _.clone(res.result || {})
                this.saveStore(operation)
                this.updateOperation(operation)
            }).catch(error => {
                this.$message.error(error || '修改手术日期失败')
            })
            } else {
                this.visibleUpdateDate = false
            }
        },
        remarkArrange (operation) {
            let options = {
                showInput: true,
                inputValue: operation.remark,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }
            this.$confirm('请输入备注内容', '备注', options).then(({ value }) => {
                if (value === operation.remark) {
                    return
                }
                let item = _.cloneDeep(operation)
                item.remark = value
                OperationService.save(item).then(res => {
                    let operation = _.clone(res.result || {})
                    this.saveStore(operation)
                    this.updateOperation(operation)
                }).catch(error => {
                    this.$message.error(error || '保存信息失败')
                })
            })
        },
        flag (operation) {
            if (!operation.emergency) return
            const type = operation.emergency === 2 ? '普通' : '急症'
            const butText = operation.emergency === 2 ? '改为急症' : '改为普通'
            const content = '当前为"急诊通道"申请的"' + type + '"手术,点击[' + butText + ']按钮更换手术类型,点击[取消]保持当前类型'
            this.$confirm(content, '切换手术类型', {
                distinguishCancelAndClose: true,
                confirmButtonText: butText,
                cancelButtonText: '取消',
            }).then(() => {
                let item = _.cloneDeep(operation)
                item.emergency = item.emergency === 2 ? 1 : 2
                OperationService.save(item).then(res => {
                    let operation = _.clone(res.result || {})
                    this.saveStore(operation)
                    this.updateOperation(operation)
                }).catch(error => {
                    this.$message.error(error || '保存信息失败')
                })
            })
        },
        showRecordImages (operation) {
            if (!operation) {
                return
            }
            this.currentOperation = _.cloneDeep(operation)
            this.visibleRecordImage = true
        },
        release (operation) {
            let ids = []
            if (operation) {
                ids.push(operation.id)
            } else {
                _.forEach(this.operations, operation => {
                    if (operation.currentState !== 4) {
                        return
                    }
                    if (operation.released) {
                        return
                    }
                    ids.push(operation.id)
                })
            }
            ids = _.join(ids)
            OperationService.release({
                ids: ids
            }).then(() => {
                this.$message({
                    message: '发送短信完成',
                    type: 'success'
                })
            }).catch(error => {
                this.$message.error(error || '发送短信失败')
            })
        },
        print (ref) {
            let printDom = _.isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref]
            if (!printDom) {
                return
            }
            if (printDom.$el) {
                printDom = printDom.$el
            }
            this.$print(printDom).then(() => {
                if (this.visiblePrintList) {
                    this.visiblePrintList = false
                }
            })
        },
        handleEditOperation (operation) {
            if (_.isEmpty(operation)) {
                this.$message('未选择手术')
                return
            }
            this.editOperation = _.cloneDeep(operation)
            this.visibleEditOperation = true
        },
        handleCloseEditOperation () {
            this.visibleEditOperation = false
            this.editOperation = {}
        },
        editOperationSuccess () {
            this.visibleEditOperation = false
        },
        listPerson() {
            this.listNurse()
            this.listAnesthesiologist()
            this.listAnesthesiaType()
            this.listAnesthesiaOperation()
        },
        listNurse () {
            if (!this.chid) {
            this.personSelection.nurse = []
                return
            }
            if (this.personSelection.nurse.length > 0) return
            NurseService.list({
                hids: this.chid,
                sort: 'spellFirst',
                order: 'asc'
            }).then(res => {
                this.personSelection.nurse = res.result || []
            })
        },
        listAnesthesiologist () {
            if (!this.chid) {
                this.personSelection.doc = []
                return
            }
            if (this.personSelection.doc.length > 0) return
            AnesthesiologistService.list({
                hids: this.chid,
                sort: 'spellFirst',
                order: 'asc'
            }).then(res => {
                this.personSelection.doc = res.result || []
            })
        },
        listAnesthesiaType () {
            const defAnesthesiaType = [{
                uid: 1,
                name: '全身麻醉'
            }, {
                uid: 2,
                name: '局部麻醉'
            }, {
                uid: 3,
                name: '椎管内阻滞麻醉'
            }, {
                uid: 4,
                name: '颈臂丛阻滞麻醉'
            }];
            if (!this.chid) {
                this.personSelection.anesthesia = defAnesthesiaType
                return
            }
            if (this.personSelection.anesthesia.length > 0) return
            AnesthesiaModeService.list({
                hid: this.chid
            }).then(res => {
                if (_.isEmpty(res.result)) {
                    this.personSelection.anesthesia = defAnesthesiaType;
                } else {
                    let data = [];
                    _.forEach(res.result, val => {
                        data.push({
                            uid: val['id'],
                            name: val['anesthesiaType']
                        })
                    });
                    this.personSelection.anesthesia = data;
                }
            })
        },
        listAnesthesiaOperation () {
            if (!this.chid) {
                this.personSelection.operations = []
                return
            }
            if (this.personSelection.operations.length > 0) return
            AnesthesiaModeService.listOperation({
                hid: this.chid
            }).then(res => {
                this.personSelection.operations = res.result || []
            })
        },
    },
    filters: {}
  }
</script>

<template>
  <el-container>
    <el-header height="45px">
        <el-form :inline="true" class="demo-form-inline left-form" size="small">
            <el-form-item>
                <el-select v-model="chid" placeholder="请选择医院" :disabled="hospitals.length <= 1">
                    <el-option
                        v-for="item in hospitals"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-radio-group v-model="currentDate">
                    <el-radio-button :label="dnumber.value" v-for="dnumber in dnumbers" :key="dnumber.value">
                    <el-badge :value="dnumberCount[dnumber.value]" :max="10" class="data-number-badge"></el-badge>
                    <span>{{dnumber.name}}</span>
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <el-form :inline="true" class="demo-form-inline right-form" size="small">
            <el-form-item>
                <el-badge :value="approveCount" class="approve-count-badge"></el-badge>
                <el-button type="primary" @click="$router.push({name: 'operation_approve'})">待审批</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="$router.push({name: 'operation_history'})">历史查询</el-button>
            </el-form-item>
        </el-form>
    </el-header>
    <el-main>
      <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
        <el-row :gutter="12" class="operation-row">
          <el-col :span="hasPermission('per_opration_001003') ? 16 : 24">
            <el-card shadow="never" :body-style="cardBodyStyle">
              <div slot="header" class="clear card-header">
                <span style="font-size: 24px;" v-if="hasPermission('per_opration_001003')">❶手术排班<small style="color:#007aff; font-size: 16px;">[从待排班列表中拖入]</small></span>
                <span style="font-size: 24px;" v-else>已经排班手术</span>
                <el-button type="primary" size="small" style="float: right;" v-if="hasPermission('per_opration_001003')" @click="release()">发送短信</el-button>
                <el-button type="default" size="small" style="float: right;" v-else @click="listState = listState === 'calendar' ? 'table' : 'calendar'">{{listState === 'calendar' ? '列表形式' : '图表形式'}}</el-button>
              </div>
              <aims-arrange-list ref="aimsArrangeList" @dropMove="handlerDropMoveArrangeList" @dropIn="handlerDropInArrangeList" @dropInError="handlerDropInError" :hid="chid" :height="650" :current-date="currentDate" @clickOperation="handleClickOperation" v-if="listState === 'calendar'"></aims-arrange-list>
              <aims-arrange-table :hid="chid" :height="650" :current-date="currentDate" v-else></aims-arrange-table>
            </el-card>
          </el-col>
          <el-col :span="8" v-if="hasPermission('per_opration_001003')">
            <el-card shadow="never" :body-style="cardBodyStyle">
              <div slot="header" class="clear card-header">
                <span style="font-size: 24px;">待排班手术<small style="color:#007aff; font-size: 16px;">[鼠标拖入时间表中排班]</small></span>
              </div>
              <div class="wait-list">
                <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                  <aims-wait-list ref="aimsWaitList" :hid="chid" :current-date="currentDate" @clickOperation="handleClickOperation"></aims-wait-list>
                </el-scrollbar>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="operation-row" v-if="hasPermission('per_opration_001003|per_opration_001004|per_opration_001005|per_opration_001013')">
          <el-col :span="24">
            <el-card shadow="never" :body-style="cardBodyStyle">
              <div slot="header" class="clear card-header">
                <span style="font-size: 24px;">❷完善排班信息</span>
                <el-button type="primary" size="small" style="float: right;" @click="visiblePrintList = true">打印</el-button>
              </div>
              <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
                <div class="operation-table-wrap" ref="operation-table">
                  <el-table
                    v-loading="operationLoading"
                    :data="operations"
                    height="650"
                    border
                    stripe
                    size="mini"
                    highlight-current-row
                    header-cell-class-name="nopadding-table-cell"
                    cell-class-name="nopadding-table-cell"
                    style="width: 100%">
                    <el-table-column header-align="center" align="center" prop="arrangedStartTime" label="时间" width="70" :formatter="tableTimeFormatter"></el-table-column>
                    <el-table-column header-align="center" align="center" prop="historySn" label="病历号" width="70"></el-table-column>
                    <el-table-column header-align="center" align="center" prop="bedid" label="床号" width="60"></el-table-column>
                    <el-table-column header-align="center" prop="patName" label="姓名" width="40"></el-table-column>
                    <el-table-column header-align="center" align="center" prop="sex" label="性别" width="30">
                      <template slot-scope="scope">
                        {{ !!scope.row.sex && scope.row.sex % 2 === 0 ? '女' : '男' }}
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" align="center" prop="age" label="年龄" width="40"></el-table-column>
                    <el-table-column header-align="center" prop="diagnoseNames" label="诊断+术式">
                      <template slot-scope="scope">
                        <span>{{scope.row.diagnoseNames}};{{scope.row.operatingNames}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" prop="device" label="设备准备" width="100"></el-table-column>
                    <el-table-column header-align="center" prop="specialPrepare" label="器械准备"></el-table-column>
                    <el-table-column header-align="center" align="center" prop="roomName" label="手术间" width="60"></el-table-column>
                    <el-table-column header-align="center" prop="operatorName" label="主刀" width="50"></el-table-column>
                    <el-table-column header-align="center" prop="assistantFirstName" label="一助" width="50"></el-table-column>
                    <el-table-column header-align="center" prop="assistantSecondName" label="二助" width="50"></el-table-column>
                    <el-table-column header-align="center" prop="washNurseName" label="洗手" width="50">
                      <template slot-scope="scope">
                        <aims-operation-selection
                          v-if="hasPermission('per_opration_001004')"
                          :hospital="chid"
                          :operation="scope.row"
                          :type="'washNurse'"
                          :selection="personSelection.nurse"
                          @saveDone="operationSelectionSaveDone"
                        ></aims-operation-selection>
                        <span v-else>{{scope.row.washNurseName || '无'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" prop="tourNurseName" label="巡回" width="50">
                      <template slot-scope="scope">
                        <aims-operation-selection
                          v-if="hasPermission('per_opration_001004')"
                          :hospital="chid"
                          :operation="scope.row"
                          :type="'tourNurse'"
                          :selection="personSelection.nurse"
                          @saveDone="operationSelectionSaveDone"
                        ></aims-operation-selection>
                        <span v-else>{{scope.row.tourNurseName || '无'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" prop="anesthesiaDocName" label="麻醉医生" width="50">
                      <template slot-scope="scope">
                        <aims-operation-selection
                          v-if="hasPermission('per_opration_001005')"
                          :hospital="chid"
                          :operation="scope.row"
                          :type="'anesthesiaDoc'"
                          :selection="personSelection.doc"
                          @saveDone="operationSelectionSaveDone"
                        ></aims-operation-selection>
                        <span v-else>{{scope.row.anesthesiaDocName || '未安排'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" prop="anesthesiaType" label="麻醉方式" width="100">
                      <template slot-scope="scope">
                        <aims-operation-selection
                          v-if="hasPermission('per_opration_001005')"
                          :hospital="chid"
                          :operation="scope.row"
                          :type="'anesthesiaType'"
                          :selection="personSelection.anesthesia"
                          :additionals="personSelection.operations"
                          @saveDone="operationSelectionSaveDone"
                        ></aims-operation-selection>
                        <span v-else>{{scope.row.anesthesiaType || '未设置'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="remark" label="标记" width="60">
                      <template slot-scope="scope">
                        <el-button 
                            type="text" :style="{ color: scope.row.emergency === 2 ? '#409EFF' : '#dd1144' }" 
                            v-if="hasPermission('per_opration_001005') && scope.row.emergency" 
                            @click="flag(scope.row)">{{scope.row.emergency === 1 ? '急症' : '普通'}}
                        </el-button>
                        <span v-else>择期</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column header-align="center" prop="remark" label="备注" width="80">
                      <template slot-scope="scope">
                        <el-button type="text" :style="{ color: scope.row.remark ? '#409EFF' : '#dd1144' }" v-if="hasPermission('per_opration_001003|per_opration_001004|per_opration_001005')" @click="remarkArrange(scope.row)">{{scope.row.remark || '点击备注'}}</el-button>
                        <span v-else>{{scope.row.remark || '无'}}</span>
                      </template>
                    </el-table-column> -->
                    <!--<el-table-column header-align="center" align="center" label="操作" width="80">
                        <template slot-scope="scope">
                            <el-button size="small" type="text" @click="showRecordImages(scope.row)">查看图片</el-button>
                        </template>
                    </el-table-column>-->
                  </el-table>
                </div>
              </el-scrollbar>
            </el-card>
          </el-col>
        </el-row>
      </el-scrollbar>
    </el-main>
    <!-- 查看手术信息 -->
    <el-dialog
      title="手术单信息"
      :visible.sync="visibleOperationInfo"
      top="0"
      append-to-body
      width="100%">
      <aims-operation-info :operation="currentOperation" ref="operation-info"></aims-operation-info>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="visibleRecordImage = true">查看图片</el-button>
        <el-button type="primary" size="small" @click="backOperation(currentOperation)" v-if="currentOperation.arranged !== 1 && hasPermission('per_opration_001003')">退回手术</el-button>
        <el-button type="primary" size="small" @click="release(currentOperation)" v-if="currentOperation.arranged === 1 && currentOperation.currentState < 5 && hasPermission('per_opration_001003')">发送短信</el-button>
        <el-button type="primary" size="small" @click="cancleArrange(currentOperation)" v-if="currentOperation.arranged === 1 && currentOperation.currentState === 4 && hasPermission('per_opration_001003')">取消排班</el-button>
        <el-button type="primary" size="small" @click="startUpdateDate(currentOperation)" v-if="currentOperation.arranged === 0 && hasPermission('per_opration_001003')">修改手术日期</el-button>
        <el-button type="primary" size="small" @click="handleEditOperation(currentOperation)" v-if="$store.getters.user.id === currentOperation.applyDoc && currentOperation.currentState < 5">修改信息</el-button>
        <el-button type="primary" size="small" @click="print('operation-info')">打 印</el-button>
        <el-button type="primary" size="small" @click="visibleOperationInfo = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印列表 -->
    <el-dialog
      :visible.sync="visiblePrintList"
      :fullscreen="true"
      append-to-body>
      <div slot="title">
        <el-button type="primary" size="small" @click="print('print-list')">打 印</el-button>
        <el-button type="default" size="small" @click="visiblePrintList = false">取消</el-button>
      </div>
      <aims-print-list ref="print-list" :data="operations" :hospitalName="currentHospital.name" :date="currentDate"></aims-print-list>
    </el-dialog>
    <!-- 查看图片 -->
    <el-dialog title="图片" :visible.sync="visibleRecordImage">
      <record-record-image-list :record="currentOperation" :enableAdd="false"></record-record-image-list>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="visibleRecordImage = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改日期 -->
    <el-dialog title="修改手术日期" :visible.sync="visibleUpdateDate" @close="handleCloseUpdateDate" :close-on-click-modal="false">
      <el-form ref="editOperationDateForm" label-position="right" label-width="100px">
        <el-form-item label="手术日期">
          <el-select v-model="operationDate" clearable placeholder="请选择日期" style="width: 100%;">
            <el-option
              v-for="item in dateSelection"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleUpdateDate = false">取 消</el-button>
        <el-button type="primary" @click="updateDate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑手术 -->
    <el-dialog title="编辑手术" :visible.sync="visibleEditOperation" @close="handleCloseEditOperation" top="0" width="1000px" :close-on-click-modal="false">
      <aims-operation-edit
        ref="operationEditRef"
        v-model="editOperation"
        :show-buttons="false"
        @cancle="visibleEditOperation = false"
        @saveDone="editOperationSuccess"
      ></aims-operation-edit>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visibleEditOperation = false">取 消</el-button>
        <el-button type="primary" @click="$refs['operationEditRef'].submit()">确定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .operation-row {
    margin-bottom: 10px;
  }
  .card-header {
    padding: 10px 0;
    line-height: 36px;
  }
  .wait-list {
    height: 650px;
  }
  .left-form {
    float: left;
  }
  .right-form {
    float: right;
  }
  .approve-count-badge {
    position: absolute;
    top: -7px;
    right: -10px;
  }
  .data-number-badge {
    position: absolute;
    top: 0px;
    right: 0px;
    opacity: 0.8;
  }
</style>
